export function setCreateNewBranchStep( step ){
    return {
        type: "SET_CREATE_NEW_BRANCH_STEP",
        payload: step
    }
}
export function setBranchIsFiscal( isFiscal ){
    return {
        type: "BRANCH_IS_FISCAL",
        payload: isFiscal
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/actions.js